module.exports = __webpack_public_path__ + "img/zh_img1.fd13c408.png";